import { render, staticRenderFns } from "./PaymentMethodUpdate.vue?vue&type=template&id=0f52fd0a&"
import script from "./PaymentMethodUpdate.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports